export enum BALANCE_TYPES {
  WALLET = 'WALLET',
  BONUS = 'BONUS',
  OVERALL = 'OVERALL'
}

export const walletExportHeaders = [
  { label: 'Created', key: 'createdAt' },
  { label: 'Stripe Transaction', key: 'stripeTransactionId' },
  { label: 'trip', key: 'rideId' },
  { label: 'Type', key: 'transactionType' },
  { label: 'Payment Method', key: 'paymentMethod' },
  { label: 'Amount', key: 'amount' },
  { label: 'Balance', key: 'totalBalance' },
  { label: 'Message', key: 'transactionMessage' }
]

export const allowedRechargeUsers = [
  'bb600d64-b7ba-4a2e-9787-b2d368eb1f0f', //Marielle

  '00ed76c6-8004-4169-b6f1-f4ae80190e64', //Haizel

  '53bd929c-fdbd-4417-ab74-72d690744c7e', //Jessica

  '06ad8a48-edc3-4ce1-b00a-a95c4a253ebe', //Angel

  'b4b20121-8ded-46c8-88da-2237463a61ff', //Yelena

  '7fbcc877-1174-48e2-8af7-4d5f54feb68e', //Kristine

  'bed19cfa-6711-4823-9927-1812e3aecd80', //Chima Gelera

  '91f07c31-05f6-4dc0-9198-bfb161fe73b3' //test user

  // 'd45fbff4-536d-41db-ada2-8e34c7303eb7' //goindev
]

export const topUpFee = 3



// WEBPACK FOOTER //
// ./src/constants/wallet.ts